import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const AdminQuestions = () => {
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    axios.get(`${API}/api/admin/questions`, { withCredentials: true }).then(r => setQuestions(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-questions">
      <h1 className="portal-page-title">Client Questions</h1>
      <p className="portal-page-subtitle">Review pre-session questions from advisory clients</p>

      {questions.length === 0 ? (
        <div className="portal-empty"><p>No questions submitted yet.</p></div>
      ) : (
        questions.map(q => (
          <div key={q.id} className="portal-card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <strong style={{ color: '#1B2A4E' }}>{q.client_name}</strong>
                <span style={{ color: '#5A6C8A', fontSize: '0.85rem', marginLeft: '0.75rem' }}>{q.client_email}</span>
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                {q.session_date && <span style={{ fontSize: '0.82rem', color: '#5A6C8A' }}>For: {q.session_date}</span>}
                <span className="portal-badge">{q.status}</span>
              </div>
            </div>
            <div style={{ marginTop: '0.75rem' }}>
              <strong style={{ fontSize: '0.8rem', color: '#5A6C8A', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Questions</strong>
              <p>{q.questions}</p>
            </div>
            {q.objectives && (
              <div style={{ marginTop: '0.5rem' }}>
                <strong style={{ fontSize: '0.8rem', color: '#5A6C8A', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Objectives</strong>
                <p>{q.objectives}</p>
              </div>
            )}
            {q.context && (
              <div style={{ marginTop: '0.5rem' }}>
                <strong style={{ fontSize: '0.8rem', color: '#5A6C8A', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Context</strong>
                <p>{q.context}</p>
              </div>
            )}
            <span style={{ fontSize: '0.78rem', color: '#9CA3AF', marginTop: '0.5rem', display: 'block' }}>Submitted: {new Date(q.created_at).toLocaleString()}</span>
          </div>
        ))
      )}
    </div>
  );
};

export default AdminQuestions;
